module.exports = __webpack_public_path__ + "static/media/inventory-list.b57700ab.svg";